import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: true,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['evolution', 'leap', 'pragmatic', 'sg-digital', 'relax', 'blueprint'],
        'live-casino': ['evolution', 'ezugi', 'pragmatic'],
        virtuals: ['leap'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel', 'promoCode'],
    complianceRestrictionSummary: true,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino', 'bingo'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'],
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: true,
    decimalLength: 2,
    depositLimitType: 'rollingType',
    depositLimitCalculationTypeConfigurable: true,
    depositRestriction: true,
    deceased: true,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text:
            '© Star Sports All rights reserved. Star Racing Ltd (licence number {{licenceNumber}}) is licensed and regulated by the Gambling Commission. Star House, 255 Old Shoreham Road. Hove, East Sussex, BN3 7ED.',
        licence_number: '009177',
        licence_url: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/009177',
        cookies_url: 'https://starsports.bet/?account=static&static=cookie-policy',
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: {
        enabled: true,
        brand: 'starsports.bet',
    },
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: 'GTM-WVG5HPZ',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: true,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'Star Sports',

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: false,
    reportDownloadOptions: ['View', 'Download', 'Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    reportsV2: false,
    redirectToNewTradingPage: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '1',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'kaching',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'Star Events',
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: true,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: true,

    /* U */
    useExtraPlacesForEvents: false,
    usePaymentFormForUniverse: {
        type: 'multi-deposit',
        apiKey: 'T1QtMzUwNTQyOkItcDEtMC02OGVlNmFiMi0wLTMwMmMwMjE0NWUyYTNjOWMzMDFjNWIxNDBlMDVkNDZlOWQ5YzY5Nzc2Yzk4ZTViYjAyMTQxZTY1MDY3ZWRmNDk3ZWFiMjIyNzJiNjAwYjgyOTUyNDhlMGM2MDYx',
        environment: 'LIVE',
        cardAccounts: {
            GBP: '1003235602',
            EUR: '1003313402',
        },
        openBanking: 'yaspa',
    },
    userTitleOptional: false,

    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        Accounts: 'Accounts-StarSports/Overview',
        Affiliate: 'Affiliate-StarSports/Overview',
        BackofficeReports: 'BackOfficeReports-StarSports/DB-Casino',
        Betting: 'Betting-StarSports/Overview',
        CasinoDashboard: 'CasinoDashboardStarSports/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-StarSports/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboardStarSports/MarketingMainDashboard',
        MarketKPIDashboard: 'MarketKPIDashboard/MarketKPIDashboardMonthly',
        PaymentsOverview: 'Payments-StarSports/Overview',
        PlatformOverview: 'Overview-StarSports/Overview',
        ProfitAndLossKPIs: 'ProfitandLossKPIsStarSports/DailyKPI',
        RacecourseDashboard: 'RacecourseDashboard-StarSports/RacecourseMediaGroupDashboard',
        RetentionDashboard: 'RetentionDashboard-StarSports/Retention',
        Segmentation: 'Segmentation-StarSports/Overview',
        TradingOverview: 'Trading-StarSports/Overview',
        TransactionsDashboard: 'TransactionsDashboardStarSports/TransactionsMainDashboard',
        AccountBalances: 'AccountBalances-StarSports/AccountBalances',
        SymplifyStats: 'SymplifyStats-StarSports/CampaignUserDashboard',
        RollingNetDeposits: 'RollingNetDeposits-StarSports/RollingNetDeposits',
        BonusEngine: 'BonusEngine-StarSports/CampaignLevel',
        CheltenhamOffers: 'CheltenhamOffers-StarSports/Cheltenham-Tier1',
    },
};
